module.exports = __webpack_public_path__ + "img/ring_r_skip_null_1@3x.4c27b80c.png";